// Logo da marca (docs/IDENTIDADE.md). O tamanho vem do texto à volta (unidade = 1em): `className="text-sm"`.
// Site = logo completo (gradiente dourado); backoffice = `mono` (dourado liso, sem gradiente).
// Não se usam os SVG "logo-*.svg" inteiros (1,2 MB, trazem o emblema em PNG): emblema WebP + wordmark vetorial.
import emblem96 from "@ecliptica/tokens/brand/emblem-96.webp";
import emblem192 from "@ecliptica/tokens/brand/emblem-192.webp";
import nameMono from "@ecliptica/tokens/brand/wordmark-name-only-mono.svg";
import name from "@ecliptica/tokens/brand/wordmark-name-only.svg";
import wordmarkMono from "@ecliptica/tokens/brand/wordmark-mono.svg";
import wordmark from "@ecliptica/tokens/brand/wordmark.svg";
import { cn } from "@ecliptica/ui";

export type LogoProps = {
  /** horizontal = emblema + nome; stacked = emblema por cima; emblem = só o emblema. */
  variant?: "horizontal" | "stacked" | "emblem";
  /** Mostra "SUN · MOON · ECLIPSE" (usa o wordmark com tagline). Só em tamanhos grandes. */
  tagline?: boolean;
  /** Dourado liso em vez do gradiente (backoffice). */
  mono?: boolean;
  className?: string;
};

export function Logo({ variant = "horizontal", tagline = false, mono = false, className }: LogoProps) {
  const nameSrc = tagline || variant === "stacked" ? (mono ? wordmarkMono : wordmark) : mono ? nameMono : name;
  const nameClass = tagline || variant === "stacked" ? "h-[2.3em] w-auto" : "h-[1.1em] w-auto";
  const emblemSize = variant === "stacked" ? "size-[5.5em]" : "size-[2.4em]";
  return (
    <span
      role="img"
      aria-label="Ecliptica"
      className={cn("inline-flex items-center", variant === "stacked" ? "flex-col gap-[0.6em]" : "gap-[0.55em]", className)}
    >
      <img
        src={emblem96}
        srcSet={`${emblem96} 1x, ${emblem192} 2x`}
        alt=""
        aria-hidden
        width={96}
        height={96}
        decoding="async"
        className={cn("shrink-0", emblemSize)}
      />
      {variant !== "emblem" && <img src={nameSrc} alt="" aria-hidden decoding="async" className={cn("max-w-none", nameClass)} />}
    </span>
  );
}
